export const SET_ORDER_OPTIONS = 'SET_ORDER_OPTIONS';
export const START_BLINKER = 'START_BLINKER';
export const MODIFY_ORDER_ITEM = 'MODIFY_ORDER_ITEM';
export const DESTROY_CART = 'DESTROY_CART';
export const RESET_ORDER = 'RESET_ORDER';
export const REPLACE_ORDER_ITEMS = 'REPLACE_ORDER_ITEMS';
export const DEEP_MODIFY_ORDER_ITEM = 'DEEP_MODIFY_ORDER_ITEM';
export const SET_CURRENT_HOURS = 'SET_CURRENT_HOURS';
export const START_ALERT_TIME = 'START_ALERT_TIME';
export const SET_TIME_LIMIT = 'SET_TIME_LIMIT';
export const SET_DEFAULT_PARAMS = 'SET_DEFAULT_PARAMS';
export const RESET_TIMERS = 'RESET_TIMERS';
